import VueI18n from 'vue-i18n'
import {hasThisBracketsTemplate} from './utils'

const ad = window.addiesaas || (window.addiesaas = {})
const adConfig = ad.config || {}
export const LTLD ='frontend' // Language TLD
export const rootTranslations = _.get(adConfig, 'translations', {})
export const translations = _.get(rootTranslations, LTLD, {})

export const sliceTranslations = (space, merge = 'shared', hasRoot = true) => {
  const root = _.omit(translations || {}, ['this'])
  let t = hasRoot ? root : {}
  merge = !space ? {} : _.merge({}, _.get(root, merge, {}))
  space = space || root
  if (_.isString(space)) {
    space =  _.get(root, space, {})
  }
  t.this = _.merge({}, merge, space)
  return _.cloneDeep(t)
}
export const factory = function (method, me) {
  if (!me) {
    return () => {}
  }
  const i18n = me && me.$i18n

  let translator = (path, defaultValue = '', ...rest) => {
    if (_.startsWith(path, '.')) {
      path = _.trimStart(path, '.')
    } else {
      path = 'this.' + _.trimEnd(path, '.')
    }
    return i18n.te(path) ? i18n[method](path, ...rest) : defaultValue
  }

  if (method === 't') {
    const basicTranslator = translator
    translator = (path, defaultValue = '', ...rest) => {
      let value = basicTranslator(path, defaultValue, ...rest)
      if (value) {
        let data = rest && rest[0]
        if (data && !_.isObject(data)) {
          data = rest[1]
        }
        if (data && !_.isObject(data)) {
          data = {}
        }
        if (hasThisBracketsTemplate(value)) {
          value = me.$$templify(value, data, ['[[', ']]'])
        }
      }
      return value
    }
  }
  return translator
}

export const setTranslations = function (space, mergeStrategy = 'shared', hasRoot = true, mergeParent = false) {
  this.$$debugLog('lang space', space, this)
  if (!this.$i18n) {
    this.$$debugLog('no .$i18n')
    return false
  }
  if (space instanceof VueI18n) {
    this.$$debugLog('lang space is a Vue18n', space)
    space = space.messages
  } else {
    this.$$debugLog('slice translations')
    space = sliceTranslations(space, mergeStrategy, hasRoot)
  }
  if (mergeParent) {
    this.$$debugLog({setSpace: space})
    this.$i18n.mergeLocaleMessage(this.$i18n.locale, space)
  } else {
    this.$i18n.setLocaleMessage(this.$i18n.locale, space)
  }

  this.$options.$$t = factory('t', this)
  this.$options.$$tc = factory('tc', this)
  this.$options.$$d = factory('d', this)
  this.$options.$$n = factory('n',this)
}

Vue.prototype.$$allTranslations = translations
Vue.prototype.$$sliceTranslations = sliceTranslations
Vue.prototype.$$setTranslations = setTranslations

export default  {
  LTLD,
  translations,
  rootTranslations,
  sliceTranslations,
  setTranslations,
  factory
}

